import React from 'react';

const TextField = (props) => {
    let { labels, textValue, handleText, requestTextField } = props;

    return(
        <div className="m-portlet m-portlet--primary m-portlet--head-solid-bg mb-0">
            <div className="m-portlet__head head-custom">
                <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                        <h3 className="m-portlet__head-text" dangerouslySetInnerHTML={{ __html: labels.Instrucciones }}></h3>
                    </div>
                </div>
            </div>
            <div className="m-portlet__body m-form__group form-group m-radio-list mb-0">
                <div className="form-group m-form__group">
                    <textarea className="form-control m-input" rows="4" value={textValue} onChange={handleText}>
                    </textarea>
                </div>
            </div>
            <div className="m-portlet__foot">
                <button className="btn m-btn--square btn-primary mr-5"
                        disabled={textValue.length <= 30}
                        onClick={requestTextField}>
                    { labels.Siguiente }
                </button>
            </div>
        </div>
    );
};

export default TextField;
